import { Logo } from "@/components/Logo";
import { HOME } from "@/constants/testIds";
import { BRAND_NAME, TAGLINE } from "@/lib/constants";

// assembled at runtime so the address is not sitting in the markup for scrapers
const USER = "deependgrooves";
const DOMAIN = ["gmail", "com"].join(".");
const address = `${USER}@${DOMAIN}`;

export const Footer = () => (
    <footer data-testid={HOME.footer} className="bg-[var(--cream)]">
        <div className="mx-auto max-w-[1240px] px-6 sm:px-10 lg:px-16 py-16">
            <div className="grid gap-12 sm:grid-cols-[auto_minmax(0,1fr)_auto] sm:items-end">
                <div>
                    <Logo size={76} />
                    <p className="font-display mt-6 text-lg">{BRAND_NAME}</p>
                    <p className="font-italic-serif mt-2 text-lg text-[var(--terracotta-ink)]">{TAGLINE}</p>
                    <nav aria-label="pages" className="mt-5 flex flex-col gap-2">
                        <a href="/submit" className="eyebrow text-[var(--ink)] opacity-70 hover:opacity-100 hover:text-[var(--terracotta-ink)] transition-colors duration-200">submit a track</a>
                        <a href="/journal" className="eyebrow text-[var(--ink)] opacity-70 hover:opacity-100 hover:text-[var(--terracotta-ink)] transition-colors duration-200">journal</a>
                        <a href="/this-week" className="eyebrow text-[var(--ink)] opacity-70 hover:opacity-100 hover:text-[var(--terracotta-ink)] transition-colors duration-200">this week</a>
                    </nav>
                </div>

                <div className="sm:text-center">
                    <p className="eyebrow opacity-80">enquiries</p>
                    <a
                        href={`mailto:${address}`}
                        data-testid={HOME.footerContact}
                        className="mt-3 inline-block border-b border-[var(--ink)] pb-1 text-base hover:text-[var(--terracotta-ink)] hover:border-[var(--terracotta-ink)] transition-colors duration-200"
                    >
                        {address}
                    </a>
                    <p className="prose-body mt-4 text-sm max-w-[32ch] sm:mx-auto opacity-80">
                        for track submissions use the form — email submissions are not read.
                    </p>
                </div>

                <p className="eyebrow opacity-80 sm:text-right">
                    © {new Date().getFullYear()} {BRAND_NAME}
                </p>
            </div>
        </div>
    </footer>
);
